export default __webpack_public_path__ + "static/media/north_royals_grap_chart.dafbeb36.jpg";